<template>
  <!--
    #1151 — Bridge component.

    The wishlist-notify confirm page is now a server-rendered Blade
    (`resources/views/wishlist/confirm-universal.blade.php`, served at
    `/wishlist-confirm/{token}` by `routes/default.php`). The Vue SPA
    route at `/wishlist-notify/:token` is kept as a bridge so any
    in-flight YOURLS short URL that still points at the old hash route
    (`/#/wishlist-notify/{token}`) lands on the universal page instead
    of mounting a stale Vue confirm component.

    This is intentionally just a redirect — no markup, no styling.
  -->
  <div></div>
</template>

<script>
export default {
    name: 'wishlistConfirm',
    mounted() {
        var token = this.$route.params && this.$route.params.token;
        if (!token) {
            window.location.replace('/');
            return;
        }
        // `replace`, not `assign` — keeps the broken hash URL out of the
        // user's back-stack so a back-tap doesn't return to a blank SPA.
        window.location.replace('/wishlist-confirm/' + encodeURIComponent(token));
    },
};
</script>
